"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("./styles");

var _jsxRuntime = require("react/jsx-runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const TickCircleSymbolIcon = ({
  title,
  ...otherProps
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", { ...otherProps,
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg",
  children: [title && /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    children: title
  }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      fill: "#FFF",
      className: "svg-fill-secondary",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M.605 6.57a1 1 0 111.999 0 1 1 0 01-2 0",
        transform: "translate(-2 -3) translate(2 3)"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M9.945 19.89C4.462 19.89 0 15.43 0 9.947a1 1 0 112 0c0 4.38 3.564 7.945 7.945 7.945s7.945-3.564 7.945-7.945S14.326 2 9.945 2a7.943 7.943 0 00-6.024 2.765A1 1 0 112.405 3.46 9.943 9.943 0 019.945 0c5.483 0 9.945 4.462 9.945 9.946s-4.462 9.945-9.945 9.945",
        transform: "translate(-2 -3) translate(2 3)"
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fill: "#4CB05D",
      d: "M10.509 16.667c-.23 0-.453-.08-.633-.225L7.368 14.4a.999.999 0 01-.142-1.406.998.998 0 011.406-.144l1.73 1.408 3.952-4.887a1 1 0 011.554 1.258l-4.582 5.667a1.007 1.007 0 01-.777.37",
      transform: "translate(-2 -3)",
      className: "svg-fill-primary"
    })]
  })]
});

TickCircleSymbolIcon.defaultProps = {
  title: undefined
};

var _default = (0, _styles.colourIcon)(TickCircleSymbolIcon);

exports.default = _default;